import { z } from 'zod';
import { characterSchema } from './character.js';
/**
 * ブロック（#257、ADR-032 A1）。**選手からブロックし、その持ち主の選手をまとめて伏せる。**
 *
 * `POST /api/v1/blocks` は選手の ID か（#277 からは）相手の利用者の ID を受け、`DELETE /api/v1/blocks/:userId` は相手の利用者の ID で解く（きっかけの選手が消えても
 * 解けるように。利用者の ID は公開の応答の `ownerId` にすでに出ている）。
 */
export const createBlockSchema = z
    .object({
    characterId: z.string().min(1).optional(),
    /**
     * 相手の利用者の ID（#277）。ともだちと対戦のロビーから、相手の選手を見る前にみえなくするとき（#264）。
     * **ともだちと対戦で同じルームに入ったことがある人だけ。**
     */
    userId: z.string().min(1).optional(),
})
    .refine((input) => (input.characterId === undefined) !== (input.userId === undefined), {
    message: 'characterId か userId の どちらか 1 つを おくってください',
    path: ['characterId'],
});
/**
 * ブロックの 1 件。せっていの「みえなくした あいて」に並べる。**持ち主の名前は返さない**（ADR-012 §4 / ADR-025）。
 */
export const blockEntrySchema = z.object({
    /** ブロックした相手（選手の持ち主）の利用者の ID。解くときに使う。 */
    userId: z.string(),
    /**
     * ブロックのきっかけの選手（どの相手かを絵と名前で思い出せるように）。**伏せない**（自分で見てブロックした相手）。
     * ただし管理者が非公開にした選手は伏せる（ADR-031）。きっかけの選手が消えていれば無い。
     */
    character: characterSchema.optional(),
    createdAt: z.string(),
});
/** ブロックを解いた結果。もともとブロックしていなければ `false`。 */
export const unblockResultSchema = z.object({
    unblocked: z.boolean(),
});
